<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M4.5 2H8l.6.5L10 6v.4l-.6 3.7q1.1 2.9 4.5 4.5l3.6-.7h.4l3.6 1.5.5.6v3.4c0 1.5-1.3 2.8-3 2.4-2.8-.6-8-2.2-11.8-6A21 21 0 0 1 2 4.9C1.8 3.2 3 2 4.5 2"
      clip-rule="evenodd"
    />
  </svg>
</template>
